import apollo from "../assets/apollo.png";
import mini from "../assets/mini.png";
import mustang from "../assets/mustang.png";
import romeo from "../assets/romeo.png";
import lotus from "../assets/lotus.png";
import mclaren from "../assets/mclaren.png";
import carousel1 from "../assets/carousel1.png";
import carousel2 from "../assets/carousel2.png";
import carousel3 from "../assets/carousel3.png";

export const images = [
  {
    image: apollo,
  },
  {
    image: mini,
  },
  {
    image: mustang,
  },
  {
    image: romeo,
  },
  {
    image: lotus,
  },
  {
    image: mclaren,
  },
];

export const CarouselData = [
  {
    img: carousel1,
  },
  {
    img: carousel2,
  },
  {
    img: carousel3,
  },
];
